import React, { useMemo } from 'react';
import { useQuery, useMutation } from 'react-query';
import Cookies from 'js-cookie';
import { Card, Header, Title, Body, EmptyState, DropOverlay, DropOverlayText, } from './styles';
import { ticketsService } from 'src/Utils/ticketsService';
import { adminUsersService } from 'src/Utils/adminUsersService';
import CommentRow from './CommentRow';
import { ConversationInput, useConversationComposer } from '../shared';
import { buildAdminMentionableUsers } from '../shared/mentionableUsers';
import { COMPLETED, TYPE_CONTACT } from 'src/Utils/constants';
import { showErrorToast } from 'src/Utils/toastHelper';
var ExternalConversation = function (_a) {
    var ticket = _a.ticket, _b = _a.fullWidth, fullWidth = _b === void 0 ? false : _b;
    var isTicketCompleted = ticket.status === COMPLETED;
    var isContactUser = Cookies.get('User') === TYPE_CONTACT;
    var _c = useQuery(['ticket-comments', ticket.id], function () { return ticketsService.getTicketComments(ticket.id); }, {
        enabled: !!(ticket === null || ticket === void 0 ? void 0 : ticket.id),
    }), commentsData = _c.data, refetchComments = _c.refetch;
    var _d = useQuery('mentionable-admin-users-external-conversation', adminUsersService.getAssignableUsers, {
        enabled: !isContactUser,
    }).data, mentionableAdminUsers = _d === void 0 ? [] : _d;
    var comments = (commentsData === null || commentsData === void 0 ? void 0 : commentsData.comments) || [];
    var _e = useConversationComposer({
        isDisabled: isTicketCompleted,
        scrollDependency: commentsData,
    }), text = _e.text, setText = _e.setText, mentionedAdminUserIds = _e.mentionedAdminUserIds, setMentionedAdminUserIds = _e.setMentionedAdminUserIds, bodyRef = _e.bodyRef, resetComposer = _e.resetComposer, files = _e.files, filePreviews = _e.filePreviews, fileInputRef = _e.fileInputRef, handleFileSelect = _e.handleFileSelect, handleAttachClick = _e.handleAttachClick, handleRemoveFile = _e.handleRemoveFile, formatFileSize = _e.formatFileSize, isDragging = _e.isDragging, handleDragEnter = _e.handleDragEnter, handleDragLeave = _e.handleDragLeave, handleDragOver = _e.handleDragOver, handleDrop = _e.handleDrop;
    var adminMentionableUsers = useMemo(function () { return buildAdminMentionableUsers(mentionableAdminUsers); }, [mentionableAdminUsers]);
    var mentionableUsers = isContactUser ? [] : adminMentionableUsers;
    var validMentionLabels = mentionableUsers.map(function (mentionableUser) { return mentionableUser.fullName; });
    var _f = useMutation(function (params) {
        return ticketsService.createComment(ticket.id, params);
    }, {
        onSuccess: function () {
            refetchComments();
            resetComposer();
        },
        onError: function (error) {
            console.error('Error creating comment:', error);
            showErrorToast(error, 'No se pudo enviar el comentario.');
        },
    }), createComment = _f[0], isCreatingComment = _f[1].isLoading;
    var handleSend = function () {
        createComment({
            content: text.trim(),
            files: files,
            mentioned_admin_user_ids: isContactUser ? [] : mentionedAdminUserIds,
        });
    };
    return (React.createElement(Card, { fullWidth: fullWidth, onDragEnter: handleDragEnter, onDragLeave: handleDragLeave, onDragOver: handleDragOver, onDrop: handleDrop },
        isDragging && (React.createElement(DropOverlay, null,
            React.createElement(DropOverlayText, null, "Soltar para adjuntar"))),
        React.createElement(Header, null,
            React.createElement(Title, null, fullWidth ? 'Conversación con Administradores' : 'Conversación con Cliente')),
        React.createElement(Body, { ref: bodyRef }, comments.length === 0 ? (React.createElement(EmptyState, null, "No hay comentarios a\u00FAn")) : (comments.map(function (comment) {
            var isClient = comment.created_by_type !== 'AdminUser';
            return (React.createElement(CommentRow, { key: comment.id, comment: comment, isClient: isClient, validMentions: validMentionLabels }));
        }))),
        React.createElement(ConversationInput, { text: text, onTextChange: setText, onSend: handleSend, files: files, filePreviews: filePreviews, fileInputRef: fileInputRef, handleFileSelect: handleFileSelect, handleAttachClick: handleAttachClick, handleRemoveFile: handleRemoveFile, formatFileSize: formatFileSize, isLoading: isCreatingComment, disabled: isTicketCompleted, footerLayout: "flex", mentionableUsers: mentionableUsers, onMentionedAdminUserIdsChange: isContactUser ? undefined : setMentionedAdminUserIds })));
};
export default ExternalConversation;
